<template>
  <div class="modal-header" style="padding: 0px">
    <div class="row">
      <div class="col-md-10">
        <h2 style="font-weight: bold"> <i :class="icon + ' text-success py-2'" style="margin-right: 15px;"></i> {{ title }}</h2>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["icon", "title"],
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/HeaderCard.vue